import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconActivityWakeBoardingComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        height="24"
        stroke="currentColor"
        strokeWidth={0.5}
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1223_1983)">
          <path d="M23.6171 18.2297C23.2505 18.0174 22.7815 18.1429 22.5694 18.5094C21.9348 19.6064 20.7543 20.2879 19.4887 20.2879C18.223 20.2879 17.0426 19.6064 16.408 18.5094C16.2709 18.2725 16.0181 18.1265 15.7443 18.1265C15.4706 18.1265 15.2178 18.2724 15.0807 18.5094C14.4461 19.6064 13.2657 20.2879 12 20.2879C10.7344 20.2879 9.55402 19.6064 8.91938 18.5094C8.78229 18.2725 8.52937 18.1265 8.2557 18.1265C7.98203 18.1265 7.72911 18.2724 7.59202 18.5094C6.95738 19.6064 5.77693 20.2879 4.51133 20.2879C3.24582 20.2879 2.06527 19.6063 1.43053 18.5093C1.2184 18.1427 0.749368 18.0176 0.382874 18.2296C0.0163795 18.4416 -0.108852 18.9107 0.103173 19.2771C1.01108 20.8463 2.70012 21.8212 4.51122 21.8212C5.94479 21.8212 7.30189 21.2104 8.2556 20.1777C9.2093 21.2105 10.5664 21.8212 11.9999 21.8212C13.4335 21.8212 14.7905 21.2105 15.7443 20.1777C16.698 21.2105 18.0552 21.8212 19.4887 21.8212C21.2999 21.8212 22.9889 20.8463 23.8968 19.2771C24.1089 18.9107 23.9836 18.4417 23.6171 18.2297Z" />
          <path d="M3.17057 7.12198C4.53339 7.12198 5.64218 6.01319 5.64218 4.65036C5.64218 3.28744 4.53339 2.17865 3.17057 2.17865C1.80764 2.17865 0.698853 3.28744 0.698853 4.65036C0.698853 6.01319 1.80764 7.12198 3.17057 7.12198ZM3.17057 3.7121C3.68785 3.7121 4.10873 4.13298 4.10873 4.65036C4.10873 5.16765 3.68785 5.58853 3.17057 5.58853C2.65318 5.58853 2.2323 5.16765 2.2323 4.65036C2.2323 4.13298 2.65318 3.7121 3.17057 3.7121Z" />
          <path d="M3.17059 7.64517C2.90316 7.64517 2.65505 7.78451 2.51591 8.01289C2.37678 8.24127 2.36666 8.52567 2.48913 8.76326L5.01216 13.6564C5.14373 13.9115 5.40667 14.0717 5.69363 14.0717H10.1L12.7473 16.9161C12.8984 17.0784 13.1031 17.1605 13.3087 17.1605C13.4957 17.1605 13.6832 17.0925 13.8308 16.955C14.1408 16.6665 14.1583 16.1815 13.8698 15.8714L10.9951 12.7826C10.85 12.6267 10.6467 12.5382 10.4338 12.5382H6.16092L4.42853 9.17862H7.58958C7.71195 9.17862 7.83248 9.14928 7.94115 9.09315L9.667 8.20252V8.41189C9.667 8.83543 10.0103 9.17862 10.4337 9.17862C10.8572 9.17862 11.2004 8.83543 11.2004 8.41189V7.7108H23.2331C23.6566 7.7108 23.9998 7.36751 23.9998 6.94407C23.9998 6.52064 23.6566 6.17735 23.2331 6.17735H11.2005V5.47626C11.2005 5.05282 10.8573 4.70953 10.4338 4.70953C10.0104 4.70953 9.6671 5.05282 9.6671 5.47626V6.47709L7.40342 7.64517H3.17059Z" />
        </g>
        <defs>
          <clipPath id="clip0_1223_1983">
            <rect fill="white" height="24" width="24" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};

IconActivityWakeBoardingComponent.displayName = 'IconActivityWakeBoarding';

const IconActivityWakeBoarding = React.memo(IconActivityWakeBoardingComponent);

export default IconActivityWakeBoarding;
